import { type ReactNode } from 'react'
import {
  ClickableTable,
  ClickableTableBody,
  ClickableTableHead,
  ClickableTableHeader,
} from '@/components/Table/ClickableTable'
import type { TableSortOrder } from '@/components/Table'
import { type ColumnId } from '@/features/admin/scope-change-requests/scope-change-request-table-columns'

export interface ScopeChangeRequestTableColumn {
  id: ColumnId
  header: string
  canSort: boolean
  sortOrder: TableSortOrder
  onSort: (sortOrder: TableSortOrder) => void
}

export interface ScopeChangeRequestTableProps {
  columns: ScopeChangeRequestTableColumn[]
  /**
   * The infinite scroll loader, rendered below the table.
   */
  loader?: ReactNode
  children?: ReactNode
}

export function ScopeChangeRequestTable({
  columns,
  loader,
  children,
}: ScopeChangeRequestTableProps) {
  return (
    <>
      <ClickableTable striped>
        <ClickableTableHead>
          {columns.map((col) => (
            <ClickableTableHeader
              key={col.id}
              canSort={col.canSort}
              sortOrder={col.sortOrder}
              onSort={col.onSort}
            >
              {col.header}
            </ClickableTableHeader>
          ))}
        </ClickableTableHead>
        <ClickableTableBody>{children}</ClickableTableBody>
      </ClickableTable>
      {loader}
    </>
  )
}
